module.exports = __webpack_public_path__ + "static/img/skin-report-1.f606dd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skinReport/skin-report-1.png
// module id = 8d6z
// module chunks = 1